import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Divider from '../../components/Divider';
import config from '../../lib/config';
import { Provider } from '../../api/adserver';

interface Props {
  searchResult?: string;
  categoryName?: string;
  provider: Provider;
}

const ThumbtackSearchResults: React.FC<Props> = (props) => {
  const { searchResult, categoryName, provider } = props;
  return (
    <View>
      <View style={styles.searchTextContainer}>
        {provider === Provider.ThumbtackCategory ? (
          <Text>All Categories</Text>
        ) : (
          <Text>
            Search Results For {searchResult ? searchResult : categoryName}
          </Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default ThumbtackSearchResults;

const styles = StyleSheet.create({
  searchTextContainer: {
    marginTop: 5,
    marginBottom: 10,
    marginStart: 15,
    height: 40,
    justifyContent: 'center',
  },
});
